import { render } from "./SystemTabCoresRelatorios.vue?vue&type=template&id=c2465f42&scoped=true&ts=true"
import script from "./SystemTabCoresRelatorios.vue?vue&type=script&lang=ts"
export * from "./SystemTabCoresRelatorios.vue?vue&type=script&lang=ts"

import "./SystemTabCoresRelatorios.vue?vue&type=style&index=0&id=c2465f42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2465f42"]])

export default __exports__